// extracted by mini-css-extract-plugin
export var action = "BetSummary-module--action--71d80";
export var bonus = "BetSummary-module--bonus--5debc";
export var bonusPayout = "BetSummary-module--bonusPayout--71396";
export var cashedOutOdds = "BetSummary-module--cashedOutOdds--33494";
export var circle = "BetSummary-module--circle--9460b";
export var emoji = "BetSummary-module--emoji--05308";
export var hideOnMobile = "BetSummary-module--hideOnMobile--927de";
export var isCashedOut = "BetSummary-module--isCashedOut--a51d2";
export var isCompact = "BetSummary-module--isCompact--90ae3";
export var isPromo = "BetSummary-module--isPromo--c70f2";
export var isWon = "BetSummary-module--isWon--63f0c";
export var label = "BetSummary-module--label--71bdd";
export var odds = "BetSummary-module--odds--4486f";
export var oddsOnly = "BetSummary-module--oddsOnly--cf833";
export var payout = "BetSummary-module--payout--e8919";
export var pickemSummary = "BetSummary-module--pickemSummary--e7232";
export var stakeHidden = "BetSummary-module--stakeHidden--3d6dd";
export var summary = "BetSummary-module--summary--0d90d";
export var value = "BetSummary-module--value--b2f40";
export var valueWrapper = "BetSummary-module--valueWrapper--aaecb";